import { useState, useEffect, useCallback } from 'react';

// ============================================================================
// Hook Return Type
// ============================================================================

export interface UseViewErrorScreenReturn {
  // Animation state
  animationData: object | null;
  isLoading: boolean;

  // Actions
  handleReload: () => void;
}

// ============================================================================
// useViewErrorScreen Hook
// ============================================================================

/**
 * Custom hook for managing ViewAdminErrorScreen component state and logic
 * Handles lazy loading of error animation and reload functionality
 */
export const useViewErrorScreen = (): UseViewErrorScreenReturn => {
  // State
  const [animationData, setAnimationData] = useState<object | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Lazy load animation
  useEffect(() => {
    if (!animationData) {
      import('../../../assets/lottie/somethingWetWrong.json')
        .then((module) => {
          setAnimationData(module.default);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Failed to load error animation:', error);
          setIsLoading(false);
        });
    }
  }, [animationData]);

  // Reload handler
  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    // Animation state
    animationData,
    isLoading,

    // Actions
    handleReload,
  };
};
